function PremiseNotFound() {
  this.name = "Premise not found";
}

export default PremiseNotFound;